<script setup>
defineProps({
  captchaPending: {
    type: Boolean,
    default: false,
  },
  captchaSolved: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["solveCaptcha"]);

const checkMarkIcon = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="24" height="24" viewBox="0 0 24 24">
    <path d="M 12 2 C 6.486 2 2 6.486 2 12 C 2 17.514 6.486 22 12 22 C 17.514 22 22 17.514 22 12 C 22 10.874 21.803984 9.7942031 21.458984 8.7832031 L 19.839844 10.402344 C 19.944844 10.918344 20 11.453 20 12 C 20 16.411 16.411 20 12 20 C 7.589 20 4 16.411 4 12 C 4 7.589 7.589 4 12 4 C 13.633 4 15.151922 4.4938906 16.419922 5.3378906 L 17.851562 3.90625 C 16.203562 2.71225 14.185 2 12 2 z M 21.292969 3.2929688 L 11 13.585938 L 7.7070312 10.292969 L 6.2929688 11.707031 L 11 16.414062 L 22.707031 4.7070312 L 21.292969 3.2929688 z"></path>
</svg>`;

const squareIcon = `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32" viewBox="0 0 32 32">
<path d="M25 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S25.552 3 25 3L25 3zM22 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S22.552 3 22 3L22 3zM19 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S19.552 3 19 3L19 3zM16 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S16.552 3 16 3L16 3zM13 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S13.552 3 13 3L13 3zM10 3C9.448 3 9 3.448 9 4s.448 1 1 1 1-.448 1-1S10.552 3 10 3L10 3zM7 3C6.448 3 6 3.448 6 4s.448 1 1 1 1-.448 1-1S7.552 3 7 3L7 3zM4 3C3.448 3 3 3.448 3 4s.448 1 1 1 1-.448 1-1S4.552 3 4 3L4 3zM4 6C3.448 6 3 6.448 3 7s.448 1 1 1 1-.448 1-1S4.552 6 4 6L4 6zM4 9c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 9 4 9L4 9zM4 12c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 12 4 12L4 12zM4 15c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 15 4 15L4 15zM4 18c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 18 4 18L4 18zM4 21c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 21 4 21L4 21zM28 3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 3 28 3L28 3zM28 6c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 6 28 6L28 6zM28 9c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 9 28 9L28 9zM28 12c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 12 28 12L28 12zM28 15c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 15 28 15L28 15zM28 18c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 18 28 18L28 18zM28 21c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 21 28 21L28 21zM28 24c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 24 28 24L28 24zM4 24c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 24 4 24L4 24zM25 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S25.552 27 25 27L25 27zM28 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S28.552 27 28 27L28 27zM22 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S22.552 27 22 27L22 27zM19 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S19.552 27 19 27L19 27zM16 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S16.552 27 16 27L16 27zM13 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S13.552 27 13 27L13 27zM10 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S10.552 27 10 27L10 27zM7 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S7.552 27 7 27L7 27zM4 27c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1S4.552 27 4 27L4 27z"></path>
</svg>`;
</script>

<template>
  <div class="captcha-box is-size-7 is-pulled-right">
    <div v-if="captchaPending" class="captcha-box__pending">
      <div class="icon-text">
        <span class="icon has-text-primary"> ... </span>
        Prüfe ...
      </div>
    </div>

    <div v-else-if="captchaSolved" class="captcha-box__solved">
      <div class="icon-text">
        <span class="icon has-text-success" v-html="checkMarkIcon"></span>
        Abgeschlossen
      </div>
    </div>
    <div v-else class="captcha-box__captcha">
      <div class="icon-text">
        <span
          class="icon has-text-grey is-clickable"
          v-html="squareIcon"
          @click="emit('solveCaptcha')"
        >
        </span>
        Anti-Roboter-Überprüfung
      </div>
    </div>
    <p class="fcaptcha-logo">freedaCaptcha</p>
  </div>
</template>

<style scoped>
* {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: 500;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}

.captcha-box {
  width: 200px;
  display: block;
  position: relative;
  padding: 0.5rem 0.5rem 1rem 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  background-color: #fff;
  color: #888;
}

.captcha-box .ico {
  font-size: 1.75em;
}

.fcaptcha-logo {
  font-size: 0.7em;
  position: absolute;
  bottom: 0.25rem;
  right: 0.5rem;
  font-weight: bolder;
}

.spinning-anim {
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
